<template>
  <div class="app-container withdraw">
    <div class="header">
      时间段
      <el-date-picker
        v-model="listQuery.start_datetime"
        type="datetime"
        value-format="yyyy-MM-dd"
        placeholder="请选择开始时间"
      ></el-date-picker>至
      <el-date-picker
        v-model="listQuery.end_datetime"
        type="datetime"
        value-format="yyyy-MM-dd"
        placeholder="请选择结束时间"
      ></el-date-picker>
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入用户名/电话"
        :clearable="true"
        style="width: 200px;margin: 0px 10px;"
      ></el-input>

      <el-select placeholder="状态" v-model="listQuery.status" :clearable="true">
        <el-option label="待审核" :value="1"></el-option>
        <el-option label="已审核" :value="2"></el-option>
        <el-option label="拒绝" :value="3"></el-option>
      </el-select>

      <el-button size="small" type="primary" style="margin-left: 15px;" @click="search">搜索</el-button>
    </div>
    <div class="fenxiao">￥总提现金额: {{cashoutMoney}}</div>
    <div class="fenxiao">￥已处理金额: {{processedMoney}}</div>
    <div class="fenxiao">￥待处理金额: {{unprocessedMoney}}</div>

    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{scope.$index+1}}</template>
      </el-table-column>
      <el-table-column label="头像" align="center" min-width="150">
        <template slot-scope="scope">
          <img v-if="scope.row.user.avatar" :src="scope.row.user.avatar" alt style="width: 40px;
  height: 40px;" />
        </template>
      </el-table-column>
      <el-table-column label="昵称" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.user.nickname}}</template>
      </el-table-column>
      <el-table-column label="姓名" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.user.nickname}}</template>
      </el-table-column>
      <el-table-column label="联系电话" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.user.phone}}</template>
      </el-table-column>
      <el-table-column label="提现金额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.money}}</template>
      </el-table-column>
      <el-table-column label="提现后余额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.after_balance}}</template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.status==1">待审核</el-tag>
          <el-tag type="success"  v-if="scope.row.status==2">已审核</el-tag>
          <el-tag type="info" v-if="scope.row.status==3">拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="提现时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.created_at}}</template>
      </el-table-column>
      <el-table-column label="处理时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.updated_at}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="handlePass(scope.row.id)"
            v-if="scope.row.status == 1"
          >处理</el-button>
          <!-- <el-button size="small" type="success" @click="handleWatch(scope.row)" v-if="scope.row.status == 2">查看</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10,20,30,50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        start_datetime: "",
        end_datetime: "",
        keyword: "",
        status:""
      },
      list: [],
      cashoutMoney: 0,
      processedMoney: 0,
      unprocessedMoney: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/user/cashout",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.cashoutMoney = result.data.cashoutMoney;
          this.processedMoney = result.data.processedMoney;
          this.unprocessedMoney = result.data.unprocessedMoney;
          this.listLoading = false;
        })
        .catch(err => {})
        .finally(err => {});
    },
    handlePass(val) {
      this.$confirm("此操作将提现通过, 是否继续?", "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/cashout/handle",
            method: "post",
            data: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleWatch(row) {
      this.$router.push("/finance/cashout?id=" + row.id + "&type=watch");
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    }
  }
};
</script>

<style>
.fenxiao {
  display: inline-block;
  padding: 20px 30px;
  margin-right: 20px;
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  margin-top: 10px;
  border-radius: 30px;
}
</style>
